import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">McMahon Family · Our Story</p>
        <h1>Welcome to the McMahon Family Hub.</h1>
        <p className="lede">
          Discover our services, explore our blogs, and learn more about our personal interests. 
          Join us in celebrating family, community, and creativity.
        </p>
        <div className="cta-row">
          <a href="#services" target="_self">
            Explore Our Services
          </a>
          <a href="#blog" target="_self" className="secondary">
            Read Our Blog
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Family Services</h2>
          <p>
            From event planning to personalized family projects, we offer a range of services to help 
            you create memorable experiences.
          </p>
        </article>
        <article>
          <h2>Our Blog</h2>
          <p>
            Dive into our thoughts and stories on family life, hobbies, and interests. We share insights 
            that inspire and connect.
          </p>
        </article>
        <article>
          <h2>Personal Interests</h2>
          <p>
            Explore our passions, from cooking to travel, and see how we embrace life as a family. 
            Join us on our adventures!
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;